import { useTranslation } from 'next-i18next';
import { useCallback } from 'react';

import { ColorInputPanel } from '@/components/Theme/ColorInputPanel';
import { ResetButton } from '@/components/Theme/ResetButton';
import { TooltipConfigProps } from '@/utils/tiptap/extensions/Tooltip/components/TooltipConfig';
import { FormControl } from '@/widgets/_components/FormControl';

export function Background(props: TooltipConfigProps) {
  const { styles, onRemoveStyle, resolvedStyles, onUpdateStyle } = props;
  const { t } = useTranslation('components', { keyPrefix: 'theme.settings' });

  const setColor = useCallback((newColor: string) => onUpdateStyle({ backgroundColor: newColor }), [onUpdateStyle]);

  return (
    <FormControl title={t('background')}>
      <ColorInputPanel
        label={t('color')}
        color={resolvedStyles.backgroundColor}
        setColor={setColor}
        ResetButton={styles.backgroundColor && <ResetButton onClick={() => onRemoveStyle('backgroundColor')} />}
      />
    </FormControl>
  );
}
